import { axiosInstance } from '../base.api';
import { paths } from '../paths';
import { Categories } from '../type/category.type';

export const getCategories = (): Promise<Categories> => {
  return axiosInstance.get(paths.categories()).then(item => item.data.data);
};
